import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import MoneyView from 'shared/components/MoneyView';
import PercentView from 'components/PercentView';
import { useTariff } from '../../../../../../hooks/useStocksTariff';

import './index.scss';

const b = b_.with('stock-top-card-tariff');

export const Tariff: React.FC = () => {
  const { t } = useTranslation();
  const { min, percent } = useTariff();
  if (!percent) {
    return null;
  }
  return (
    <div className={b()}>
      <div className={b('title')}>{t('Fees')}</div>
      <div className={b('values')}>
        <div className={b('value')}>
          {t('enter and leave fee')} <PercentView>{percent}</PercentView>
          {t('but not less than')} <MoneyView>{min}</MoneyView>
        </div>
      </div>
    </div>
  );
};
